import Marionette from "backbone.marionette";
import $ from "jquery";
import "slick-carousel";

import { heapTrack } from "lib/analytics";
import { STORAGE_KEY } from "lib/config";
import { calculateMatchScore } from "lib/util";
import wsStorage from "lib/wsStorage";
import JobAlertsComponent from "js/components/job-alerts";

import component from "../../../components";
import templ from "../../../templates/review";
import events from "../../../events";

export default Marionette.View.extend({
    template: templ.Questions,
    ui: {
        questionContainer: ".app-summary__questions-body",
        questionAnswer: "js-question-answer",
        carousel: ".app-summary__questions-carousel",
        autoApplyCard: ".app-summary__auto-apply",
        autoApplyEnabled: ".app-summary__auto-apply-enabled",
        jobAlertsCard: ".app-summary__job-alerts",
        jobAlertsEnabled: ".app-summary__job-alerts-enabled",
        optionCards: ".app-summary__option-card",
        optionDisabled: ".app-summary__option-disabled",
    },
    events: {
        "click @ui.questionAnswer": "trackClick",
    },
    serializeData() {
        return {
            matchScore: calculateMatchScore(this.options.answerCount),
            questions: this.options.questions,
            confirmCount: this.options.confirmCount,
            phone: this.options.phone,
        };
    },
    onRender() {
        if (this.options.showJobAlertsPromo) {
            heapTrack("App Summary - Show Job Alert Card");

            new JobAlertsComponent({
                el: this.ui.jobAlertsCard,
                handleChange: this.onJobAlertsChange.bind(this),
            }).render();
        } else if (this.options.autoApplyEnabled !== null) {
            heapTrack("App Summary - Show Questions");

            this.ui.autoApplyCard.hide();
            this.ui.questionContainer.show();
            if (this.options.autoApplyEnabled) {
                this.ui.autoApplyEnabled.show();
            } else {
                this.ui.optionDisabled.show();
            }
        } else {
            heapTrack("App Summary - Show Auto-Apply");

            new component.AutoApply({
                el: this.ui.autoApplyCard,
                handleAutoApplyChange: this.autoApplyOptIn.bind(this),
            }).render();
        }

        this.ui.carousel.slick({
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            nextArrow: $.svgIcon("chevron-right", "slick-next"),
            prevArrow: $.svgIcon("chevron-left", "slick-prev"),
        });
    },
    trackClick(event) {
        event.preventDefault();

        events.track("APP_SUMMARY_QUESTIONS", "CLICK");

        setTimeout(() => {
            window.location.href = $(event.currentTarget).attr("href");
        }, 0);
    },
    onJobAlertsChange(enabled) {
        this.showQuestions(this.ui.jobAlertsCard, this.ui.jobAlertsEnabled, enabled);

        if (!enabled) {
            wsStorage.setItem(STORAGE_KEY.SUMMARY_JOB_PROMO, true, 2592000 * 1000); // 30 days
        }
    },
    autoApplyOptIn(enabled) {
        this.showQuestions(this.ui.autoApplyCard, this.ui.autoApplyEnabled, enabled);
        this.options.handleAutoApplyChange(enabled);
    },
    showQuestions($container, $enabled, enabled) {
        $container.fadeOut(300, () => {
            if (enabled) {
                $enabled.show();
            } else {
                this.ui.optionDisabled.show();
            }
            this.ui.questionContainer.fadeIn();
        });
    },
});
